import { createBrowserClient } from "@supabase/ssr"

import { SUPABASE_PUBLISHABLE_KEY, SUPABASE_URL } from "./env"

/**
 * Browser Supabase client for use in Client Components.
 *
 * The result can be memoised safely — `createBrowserClient` returns a
 * singleton keyed by URL + key, so repeated calls don't leak connections.
 *
 * Canonical import:
 *   import { createClient } from "@/lib/supabase/browser"
 */
export function createClient() {
  return createBrowserClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY)
}
